import { AddButton } from 'components/AddButton';
import { usePartnerAdmin } from 'hooks/usePartnersAdmin';
import { useRouteMatch } from 'react-router-dom';

import { Grid } from '@mui/material';

import { DashboardTitle } from '../../../components/Titles';
import { PartnerList } from './PartnerList';
import { PartnerSearchBar } from './PartnerSearchBar';
import { useEffect } from 'react';

export const Partner = () => {
  const { partners, loading, maxPage, page, setPage, getPartnersCb } =
    usePartnerAdmin();

  let { path } = useRouteMatch();

  useEffect(() => {
    getPartnersCb(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE PARCEIROS" />
      </Grid>
      <Grid item xs={12}>
        <PartnerSearchBar />
      </Grid>
      <Grid item container xs={12} justifyContent="flex-end">
        <AddButton path={`${path}/add`} />
      </Grid>
      <Grid item xs={12}>
        <PartnerList
          loading={loading}
          {...partners}
          currentPage={page}
          setPage={setPage}
          maxPage={maxPage}
        />
      </Grid>
    </Grid>
  );
};

